import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { ENABLED, LOCAL_STORAGE_KEYS } from "../../../../constants/Constants";
import { PublicVariables } from "../../../../constants/PublicVariables";
import { PARTICIPANT_TYPE, TAB_OPTIONS } from "../../../../constants/InviteConstants";
import EmailTab from "./EmailTab/EmailTab";
import SmsTab from "./SMSTab/SmsTab";
import CopyTab from "./CopyTab/CopyTab";
import CenterModal from "../../../UI/Modal/CenterModal";
import { generateInviteUrl } from "../../../../shared/utility";
import CustomToast from "../../../UI/customToast";
import { inviteParticipant, inviteParticipantReset } from "../../../../actions/onLoadFunctionAction";
import storage from "../../../../services/storage";
import { setIsInviteModalOpen } from "../../../../reducers/invite-reducer";
import WhatsAppTab from "./WhatsAppTab/WhatsAppTab";

const InviteParticipant = () => {
    const dispatch = useDispatch();

    const smsInputValueRef = useRef("");
    const whatsAppInputValueRef = useRef("");
    const { privacyPolicyData, inviteParticipantLoading, inviteParticipantData, inviteParticipantError } = useSelector((state) => state.onLoadData);
    const { isInviteModalOpen } = useSelector((state) => state.inviteParticipant);

    const [selectedTab, setSelectedTab] = useState(TAB_OPTIONS.SMS);
    const [userInviteType, setUserInviteType] = useState(PARTICIPANT_TYPE.GUEST);
    const [inviteUrl, setInviteUrl] = useState("");

    const [emails, setEmails] = useState([]);
    const [isDoneBtnVisible, setIsDoneBtnVisible] = useState(false);
    const [isSentBtnVisible, setIsSentBtnVisible] = useState(false);

    const localisedValues = useLanguageChange();

    useEffect(() => {
        const url = generateInviteUrl(userInviteType);
        setInviteUrl(url);
    }, [userInviteType]);

    useEffect(() => {
        if (inviteParticipantLoading) return;

        if (inviteParticipantData) {
            CustomToast.success(localisedValues["invite_sent_successfully"]);

            setIsSentBtnVisible(true);
            setIsDoneBtnVisible(true);

            if (selectedTab === TAB_OPTIONS.SMS || selectedTab === TAB_OPTIONS.WHATSAPP) {
                smsInputValueRef.current = "";
                whatsAppInputValueRef.current = "";
                storage.set(LOCAL_STORAGE_KEYS.PREV_COUNTRY_CODE, inviteParticipantData.isoCode);
            } else {
                setEmails([]);
            }
        } else if (inviteParticipantError) {
            CustomToast.error(inviteParticipantError.message);
        }
    }, [inviteParticipantLoading, inviteParticipantData, inviteParticipantError]);

    const handleCloseModal = () => {
        dispatch(setIsInviteModalOpen(false));
        dispatch(inviteParticipantReset());
    };

    const handleSendInvite = (payload) => {
        payload.url = inviteUrl;
        //// payload.url = "https://ajaytest.blitzz.app/j/204666842?m=0&s=1"; // test locally
        dispatch(inviteParticipant(payload));
    };

    const handleClickOnTab = (tab) => {
        setSelectedTab(tab);
        setIsSentBtnVisible(false);
    };

    const header = (
        <>
            <h5 className='modal-title'>{localisedValues.invite_participant_lable}</h5>
            <button type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close' onClick={handleCloseModal}>
                <span className='btn-icon icon-close'></span>
            </button>
        </>
    );

    const body = (
        <>
            <div className='invite-participant-tab-nav'>
                <ul className='nav nav-tabs' role='tablist'>
                    <li className='nav-item'>
                        <button
                            className='nav-link invite-participant-nav-link active'
                            id='invite-sms-tab'
                            data-bs-toggle='tab'
                            data-bs-target='#invite-sms'
                            type='button'
                            role='tab'
                            aria-selected='true'
                            onClick={() => handleClickOnTab(TAB_OPTIONS.SMS)}
                        >
                            <span className='btn-icon icon-sms'></span>
                            <span className='btn-text'>{localisedValues.sms_label}</span>
                        </button>
                    </li>
                    <li className='nav-item'>
                        <button
                            className='nav-link invite-participant-nav-link'
                            id='invite-whatsapp-tab'
                            data-bs-toggle='tab'
                            data-bs-target='#invite-whatsapp'
                            type='button'
                            role='tab'
                            aria-selected='true'
                            onClick={() => handleClickOnTab(TAB_OPTIONS.WHATSAPP)}
                        >
                            <span className='btn-icon icon-whatsapp'></span>
                            <span className='btn-text'>{localisedValues.whatsapp_label}</span>
                        </button>
                    </li>
                    <li className='nav-item'>
                        <button
                            className='nav-link invite-participant-nav-link'
                            id='invite-email-tab'
                            data-bs-toggle='tab'
                            type='button'
                            role='tab'
                            aria-selected='false'
                            data-testid='emailTabBtn'
                            onClick={() => handleClickOnTab(TAB_OPTIONS.EMAIL)}
                        >
                            <span className='btn-icon icon-email'></span>
                            <span className='btn-text'>{localisedValues.email}</span>
                        </button>
                    </li>
                    <li className='nav-item'>
                        <button
                            className='nav-link invite-participant-nav-link'
                            id='invite-copy-tab'
                            data-bs-toggle='tab'
                            data-bs-target='#invite-copy-link'
                            type='button'
                            role='tab'
                            aria-selected='false'
                            data-testid='copyTabBtn'
                            onClick={() => handleClickOnTab(TAB_OPTIONS.COPY)}
                        >
                            <span className='btn-icon icon-copy'></span>
                            <span className='btn-text'>{localisedValues.copy}</span>
                        </button>
                    </li>
                </ul>
            </div>
            <div className='tab-content'>
                {selectedTab === TAB_OPTIONS.SMS && (
                    <SmsTab
                        handleSendInvite={handleSendInvite}
                        handleCloseModal={handleCloseModal}
                        isSentBtnVisible={isSentBtnVisible}
                        isDoneBtnVisible={isDoneBtnVisible}
                        mobileNumberRef={smsInputValueRef}
                    />
                )}
                {selectedTab === TAB_OPTIONS.WHATSAPP && (
                    <WhatsAppTab
                        isDoneBtnVisible={isDoneBtnVisible}
                        handleCloseModal={handleCloseModal}
                        isSentBtnVisible={isSentBtnVisible}
                        handleSendInvite={handleSendInvite}
                        inviteUrl={inviteUrl}
                        mobileNumberRef={whatsAppInputValueRef}
                    />
                )}
                {selectedTab === TAB_OPTIONS.EMAIL && (
                    <EmailTab
                        privacyPolicyData={privacyPolicyData}
                        inviteParticipantLoading={inviteParticipantLoading}
                        isDoneBtnVisible={isDoneBtnVisible}
                        inviteUrl={inviteUrl}
                        emails={emails}
                        setEmails={setEmails}
                        localisedValues={localisedValues}
                        handleSendInvite={handleSendInvite}
                        handleCloseModal={handleCloseModal}
                        isSentBtnVisible={isSentBtnVisible}
                    />
                )}
                {selectedTab === TAB_OPTIONS.COPY && (
                    <CopyTab
                        inviteUrl={inviteUrl}
                        isForGuest={userInviteType === PARTICIPANT_TYPE.GUEST}
                        localisedValues={localisedValues}
                        languageCode={PublicVariables.currentLanguageObj.languageCode}
                        isDoneBtnVisible={isDoneBtnVisible}
                        handleCloseModal={handleCloseModal}
                    />
                )}

                {PublicVariables.featureFlag?.SHOWMEOBSERVER === ENABLED && (
                    <div className='radio-btn-list inline invite-radio-btn' data-testid='inviteRadioBtnList'>
                        <div className='radio-btn-box default-radio-btn'>
                            <label>
                                <input
                                    type='radio'
                                    name='inviteradio'
                                    data-testid='guestRadioButton'
                                    checked={userInviteType === PARTICIPANT_TYPE.GUEST}
                                    onChange={() => {
                                        setUserInviteType(PARTICIPANT_TYPE.GUEST);
                                    }}
                                />
                                <span className='for-design'></span>
                                {localisedValues.guest_lable}
                            </label>
                        </div>
                        <div className='radio-btn-box default-radio-btn'>
                            <label>
                                <input
                                    type='radio'
                                    name='inviteradio'
                                    data-testid='silentObserverRadioButton'
                                    checked={userInviteType === PARTICIPANT_TYPE.SILENT_OBSERVER}
                                    onChange={() => {
                                        setUserInviteType(PARTICIPANT_TYPE.SILENT_OBSERVER);
                                    }}
                                />
                                <span className='for-design'></span>
                                {localisedValues.Silent_observer_lable}
                            </label>
                            <div className='custom-tooltip right-tooltip default-custom-tooltip'>
                                <div className='custom-tooltip-icon'>
                                    <span className='icon-info'></span>
                                </div>
                                <div className='custom-tooltip-content'>
                                    <div className='custom-tooltip-in'>
                                        <p data-testid='silentObserverTooltipLable'>{localisedValues.invite_participant_tooltip_lable}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );

    return (
        <CenterModal
            showModal={isInviteModalOpen}
            closeModal={handleCloseModal}
            modalClass='modal-medium invite-participant-modal'
            className='modal-dialog modal-dialog-centered'
            bodyClassName=''
            header={header}
            body={body}
            backdrop={"static"}
            keyboard={false}
        />
    );
};

export default InviteParticipant;
